<template v-if="data">
  <section class="page-intro" :class="data.show_image ? 'has-image' : ''">
    <div class="page-intro-content">
      <span class="label">{{ data.label }}</span>
      <h1>{{data.title}}</h1>
    </div>

    <div v-if="data.show_image" class="page-intro-img">
      <img v-if="data.image" :src="data.image.url" :alt="data.image.alt">
      <img v-else-if="'artwork' in artist" :src="artist.artwork[0].images[0].image.url" :alt="artist.artwork[0].images[0].image.alt">
    </div>
  </section>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      artist: {},
    }
  },
  methods: {
    async getRandomArtist() {
      const response = await fetch(`${this.$root.api_url}getParticipants?random=true`);
      const artists = await response.json();
      this.artist = artists[0];
    },
  },
  mounted() {
    this.getRandomArtist();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page-intro {
  display: flex;
  @media (max-width: @mobile) {
    display: block;
  }
  @media (max-width: 800px) {
    background-size: 7vw;
  }
  &.has-image {
    .page-intro-content {
      @media (min-width: @mobile) {
        width: 50%;
      }
    }
    .page-intro-img {
      @media (min-width: @mobile) {
        width: 50%;
      }
    }
  }
  .page-intro-content {
    padding: 8vh 115px;
    @media (max-width: 800px) {
      padding: 3vh 60px;
    }
    h1 {
      font-size: 38px;
      font-weight: normal;
      @media (max-width: @mobile) {
        font-size: 22px;
      }
    }
    .label {
      display: inline-flex;
      margin-bottom: 30px;
      text-transform: uppercase;
      font-family: @fontSecondary;
      font-size: 32px;
      font-weight: bold;
      @media (max-width: @mobile) {
        margin-bottom: 20px;
        font-size: 18px;
      }
      span {
        min-width: 10px;
        padding: 3px;
        transform: translateY(3px);
        font-family: @fontPrimary;
      }
    }
  }

  .page-intro-img {
    position: relative;
    img {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: -1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageIntro.vue